import { Description } from '@material-ui/icons';
import resume from '../assets/pdf/massab_cv.pdf';
import profileimage from '../assets/png/massab.png';

export const headerData = {
    name: 'Muaasab Sabir',
    title: "Digital Marketing & Ads Manager / AI Automation",
    desciption: "I’m an Experienced Digital Marketing & Ads Manager with a strong focus on creating data-driven strategies that boost traffic, strengthen brand visibility, and deliver measurable ROI. In addition to traditional marketing, I integrate the power of AI automation. From AI-driven ad optimization to automated lead nurturing and chatbots, I use intelligent tools to streamline workflows.",
    image: profileimage,
    resumePdf: resume
}
